import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { girisYap, getDoktorlar } from '../services/api';

export default function Login() {
  const [doktorlar,    setDoktorlar]    = useState([]);
  const [seciliDokKod, setSeciliDokKod] = useState('');
  const [parola,       setParola]       = useState('');
  const [hata,         setHata]         = useState('');
  const [yukleniyor,   setYukleniyor]   = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getDoktorlar()
      .then(res => setDoktorlar(res.data))
      .catch(() => setHata('Kullanıcı listesi yüklenemedi.'));
  }, []);

  const handleGiris = async (e) => {
    e.preventDefault();
    if (!seciliDokKod) { setHata('Lütfen kullanıcı seçiniz.'); return; }
    setHata('');
    setYukleniyor(true);
    try {
      const res = await girisYap(parseInt(seciliDokKod), parola);
      localStorage.setItem('kullanici', JSON.stringify(res.data));
      localStorage.setItem('giristipi', 'normal');
      navigate('/bekleme');
    } catch {
      setHata('Kullanıcı adı veya şifre hatalı.');
    } finally {
      setYukleniyor(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg, #e8f4f8 0%, #f0eaff 50%, #eafaf1 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 24
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src="/images/kurum_logo_200.png" alt="Logo" style={{ maxWidth: '100%', objectFit: 'contain' }} />
        </div>

        {/* Kart */}
        <div style={{
          background: '#fff', borderRadius: 18,
          boxShadow: '0 8px 32px rgba(100,80,200,.12)',
          overflow: 'hidden'
        }}>
          {/* Başlık */}
          <div style={{ background: 'linear-gradient(135deg, #7C5CBF, #1D9E75)', padding: '18px 24px' }}>
            <div style={{ color: '#fff', fontSize: 17, fontWeight: 700 }}>📋 Personel Girişi</div>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 3 }}>Sisteme giriş yapın</div>
          </div>

          {/* Form */}
          <form onSubmit={handleGiris} style={{ padding: '22px 24px' }}>

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#7C5CBF', display: 'block', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.5px' }}>
                Kullanıcı Adı
              </label>
              <select
                value={seciliDokKod}
                onChange={e => setSeciliDokKod(e.target.value)}
                required
                style={{ border: '1.5px solid #c5b3f0', borderRadius: 8, background: '#faf8ff', color: '#3d2f6e', fontWeight: 500 }}
              >
                <option value="">LÜTFEN SEÇİNİZ</option>
                {doktorlar.map(d => (
                  <option key={d.dokKod} value={d.dokKod}>{d.adSoyad}</option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: 22 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: '#7C5CBF', display: 'block', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.5px' }}>
                Şifre
              </label>
              <input
                type="password"
                placeholder="Şifrenizi girin"
                value={parola}
                onChange={e => setParola(e.target.value)}
                required
                style={{ border: '1.5px solid #c5b3f0', borderRadius: 8, background: '#faf8ff', color: '#3d2f6e' }}
              />
            </div>

            {hata && (
              <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>
                {hata}
              </div>
            )}

            <button
              type="submit"
              disabled={yukleniyor}
              style={{
                width: '100%', padding: '13px',
                background: 'linear-gradient(135deg, #7C5CBF, #a07de0)',
                color: '#fff', border: 'none', borderRadius: 10,
                fontSize: 15, fontWeight: 700, cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(124,92,191,.35)'
              }}
            >
              {yukleniyor ? 'Giriş yapılıyor...' : '🔐 GİRİŞ YAP'}
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}
